export const LIST_ORDER_PAYMENT = 'LIST_ORDER_PAYMENT';
export const LIST_ORDER = 'LIST_ORDER';
export const RESEND_EMAIL_ORDER = 'RESEND_EMAIL_ORDER';
export const CANCEL_ORDER = 'CANCEL_ORDER';
